import * as React from 'react'
import PropTypes from 'prop-types'
import LogoM from '../inumet/logo/LogoM'
import MeteogramasMarino from './MeteogramasMarino'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { useEffect } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

import './dialogosMarino.css'
import { DialogTitle, Grid, IconButton } from '@mui/material'

function MeteogramasMarinoDialog({
    dataPuertos,
    horasPronostico,
    horasResolTemporal,
    open,
    handleClose,
    pathPrefixLogo,
}) {
    const theme = useTheme()
    const mcel = useMediaQuery(theme.breakpoints.down('md'))

    useEffect(() => {
        const handleBackButton = (event) => {
            event.preventDefault()
            handleClose()
            window.history.pushState(null, null, window.location.href) // Evita navegación adicional en la historia
        }

        if (open) {
            window.history.pushState(null, null, window.location.href)
            window.addEventListener('popstate', handleBackButton)
        } else {
            window.removeEventListener('popstate', handleBackButton)
        }

        return () => {
            window.removeEventListener('popstate', handleBackButton)
        }
    }, [open, handleClose])

    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                fullScreen={mcel}
                maxWidth={'xl'}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                PaperProps={{
                    sx: {
                        backgroundColor: '#f2f2f2', // Cambia el color de fondo aquí
                    },
                }}
            >
                <DialogTitle className="dialog-title">
                    <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Grid item>
                            <LogoM
                                pathPrefix={pathPrefixLogo}
                                mr={3}
                                width={120}
                            />
                        </Grid>
                        {!mcel && (
                            <Grid item>
                                <span className="titulo">METEOGRAMAS</span>
                            </Grid>
                        )}
                        <Grid item>
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    {mcel && (
                        <Grid
                            container
                            direction="column"
                            alignItems="flex-start"
                        >
                            <Grid item>
                                <span className="titulo">METEOGRAMAS</span>
                            </Grid>
                        </Grid>
                    )}
                </DialogTitle>
                <DialogContent>
                    <MeteogramasMarino
                        dataPuertos={dataPuertos}
                        horasPronostico={horasPronostico}
                        horasResolTemporal={horasResolTemporal}
                    />
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose}>
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default MeteogramasMarinoDialog

MeteogramasMarinoDialog.propTypes = {
    dataPuertos: PropTypes.object,
    horasPronostico: PropTypes.number,
    horasResolTemporal: PropTypes.number,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    pathPrefixLogo: PropTypes.string,
}
